import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

import PanelCard from '../panel-card/panel-card';
import UserImage from '../user-image/user-image';

import { ArrowHorizontal } from '../icons/icons';
// PdfFileIcon,

import './notification-quotation.scss';
import FileItem from '../file-item/file-item';
import Action from '../action/action';
import UserGroup from '../user-group/user-group';

function NotesQuotationList({ data }) {
  const [t] = useTranslation('managecustoms');
  return (
    <PanelCard cardTitle={t('quoteApprovalFlow.quotationComments')}>
      <div className="progress-tab comment-tab-container large">
        <div className="comment-list-container">
          {data?.map((noteData) => (
            <div
              className="comment-wrapper mt-20 text-left"
              key={noteData?._id}
            >
              <p className="heading">{noteData?.label}</p>
              <div className="main-content">
                <p
                  className="date-text"
                  style={{
                    color: noteData?.colorCode
                      ? noteData?.colorCode
                      : '#c9c9c9',
                  }}
                >
                  {noteData?.subLabel}
                </p>

                {/* Requester and User Details */}
                {!noteData?.quoteCreated && (
                  <div className="user-details d-flex align-center">
                    <span className="mr-10">
                      <UserImage
                        name={noteData?.requester?.email}
                        shortName={`${noteData?.requester?.firstName?.[0]}${noteData?.requester?.lastName?.[0]}`.toUpperCase()}
                        size="small"
                        path={noteData?.requester?.profilePicture}
                      />
                    </span>
                    <span className="mr-10">
                      <ArrowHorizontal />
                    </span>
                    <UserGroup
                      userData={noteData?.provider}
                      sliceVal={12}
                      statusIcon
                      moreZindex={1043}
                      defaultTitle
                    />
                    {false &&
                      noteData?.provider?.map((provider) => (
                        <UserImage
                          key={provider?.email}
                          name={provider?.email}
                          shortName={`${provider?.firstName?.[0]}${provider?.lastName?.[0]}`?.toUpperCase()}
                          size="small"
                          className="ml-10"
                          path={provider?.profilePicture}
                          status={provider?.status}
                          statusIcon
                        />
                      ))}
                  </div>
                )}

                <div className="document-details">
                  <div className="d-flex align-center">
                    {noteData?.documentLink.slice(0, 2).map((doc) => {
                      return (
                        <a href={doc.url}>
                          <FileItem
                            fileName={doc.originalName}
                            disabledRemove
                            className="border-none my-0 ml-0"
                            formatLimit={30}
                          />
                        </a>
                      );
                    })}
                    {noteData?.documentLink?.length > 2 && (
                      <Action
                        label={`+${(noteData?.documentLink?.length ?? 0) - 2}`}
                        className="icon-button s-medium justify-center primary ml-5"
                      >
                        {noteData?.documentLink.slice(2).map((moredoc) => {
                          return (
                            <a href={moredoc.url}>
                              <FileItem
                                fileName={moredoc.originalName}
                                disabledRemove
                                className="border-none m-0 w-100"
                                formatLimit={30}
                              />
                            </a>
                          );
                        })}
                      </Action>
                    )}

                    {/* <PdfFileIcon />
                    <a
                      href={noteData?.documentLink[0]?.url}
                      className="doc-title ml-10"
                    >
                      {noteData?.documentLink?.[0]?.originalName}
                    </a> */}
                  </div>
                </div>
                <p className="note">{ReactHtmlParser(noteData?.comment)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PanelCard>
  );
}
NotesQuotationList.propTypes = {
  data: PropTypes.instanceOf(Array),
};

NotesQuotationList.defaultProps = {
  data: [],
};

export default NotesQuotationList;
